import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import uuid from 'uuid/v1';
import { MSThemeProvider, Typography } from '@bitsoex/react-design-system/foundations';
import { Stack, Section } from '@components';
import { useIntl } from 'react-intl';
import { messages } from './Business.messages';
import { ContactFormSection, FormContainer } from './Business.styles';

const hubSpot = {
  us: `hbspt.forms.create({ region: "na1", portalId: "9439345", formId: "c09dcef4-4408-422c-ace5-9ff2f08cea72" });`,
  br: `hbspt.forms.create({ region: "na1", portalId: "9439345", formId: "359ae70e-ffed-496c-b2e0-a4a6e0ab3ac9" });`,
  ar: `hbspt.forms.create({ region: "na1", portalId: "9439345", formId: "1d9958d5-2a76-4012-8807-6c5b6e457420" });`,
  co: `hbspt.forms.create({ region: "na1", portalId: "9439345", formId: "41c51840-c1aa-44ec-86a1-e35a71f27b76" });`,
  mx: `hbspt.forms.create({ region: "na1", portalId: "9439345", formId: "e432b61e-fcfa-496c-bc0d-0184df72efd0" });`,
};

const BusinessContact = () => {
  const [scriptId, setScriptId] = useState('');
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const router = useRouter();
  const intl = useIntl();

  useEffect(() => {
    setScriptId(uuid());
  }, [router.locale]);

  useEffect(() => {
    if (!scriptLoaded) return;

    eval(hubSpot[router.locale ?? 'us']);
  }, [scriptLoaded, router.locale]);

  return (
    <ContactFormSection id="contact-form">
      <Section as="div">
        <FormContainer>
          <Stack gap="32" alignItems="center" direction="column">
            <Typography tag="h2" variant="titleMedium" color="onSurfaceHigh">
              {intl.formatMessage(messages.title)}
            </Typography>
            <Typography variant="bodyLarge" tag="p" color="onBackgroundMedium">
              {intl.formatMessage(messages.subtitle)}
            </Typography>
          </Stack>
          {scriptId && (
            <>
              <Script
                id={scriptId}
                type="text/javascript"
                src="//js.hsforms.net/forms/embed/v2.js"
                strategy="lazyOnload"
                onLoad={() => {
                  setScriptLoaded(true);
                }}
              />
              <div
                id={scriptId}
                dangerouslySetInnerHTML={{ __html: `<Script>${hubSpot[router.locale ?? 'us']}</Script>` }}
              />
            </>
          )}
        </FormContainer>
      </Section>
    </ContactFormSection>
  );
};

export default BusinessContact;
